import MuiTab from '@mui/material/Tab';
import { styled } from '@mui/system';
import colors from '../../../assets/colors';

const StyledTab = styled(MuiTab, {
  shouldForwardProp: (prop) => prop !== 'yellow',
})(({ theme, yellow }) => ({
  backgroundColor: colors.oldAgroweGreen,
  textTransform: 'none',
  minWidth: '20%',
  fontWeight: theme.typography.fontWeightBold,
  fontSize: 32,
  marginRight: theme.spacing(4),
  color: colors.white,
  borderRadius: 4,
  '&:hover': {
    color: colors.white,
    opacity: 0.5,
    ...(yellow && { opacity: 0.8, backgroundColor: colors.yellow }),
  },
  '&.Mui-selected': {
    color: colors.white,
    fontWeight: theme.typography.fontWeightBold,
    ...(yellow && { backgroundColor: colors.yellow }),
  },
  '&:focus': {
    color: colors.white,
    fontWeight: theme.typography.fontWeightBold,
  },
}));

const Tab = (props) => <StyledTab disableRipple {...props} />;
export default Tab;
